'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

export interface ItemCountDSProps {
  totalItems: number
}

const itemCountClass = css({
  textStyle: 'body-12',
  color: 'mediumgray',
  textAlign: 'center',
  textTransform: 'lowercase',
  w: 'full',
  display: { base: 'block', lg: 'none' },
  mb: 'space-20',
})

export const ItemCountDS = ({ totalItems }: ItemCountDSProps) => {
  const { t } = useTranslation('common')

  return (
    <div className={itemCountClass}>{t(totalItems === 1 ? 'totalitems_item' : 'totalitems_items', { totalItems })}</div>
  )
}
